import { ABTestsContentV2 } from "@/components/ab-tests/ABTestsContentV2";
import { useProductDetailContext } from "@/contexts/ProductDetailContext";

export default function ProductAbTestsPage() {
  const { productDetail } = useProductDetailContext();

  return (
    <div className="p-6 [&_table]:border-0 [&_.v2-table-section]:rounded-none [&_.v2-table-section]:border-x-0 [&_.v2-table-section]:border-b-0">
      <ABTestsContentV2
        productId={productDetail.id}
        heroAsin={productDetail.asin}
      />
    </div>
  );
}
